import { VueConstructor } from 'vue'
import routes from './router/routes'

const KwixeoHelp = {
  install: function (Vue: VueConstructor, options: KwixeoHelp.PluginOptions): void {
    Vue.prototype.$kwHelp = options

    this.installRoutes(options)

    require('./fontawesome')
  },

  installRoutes: (options: KwixeoHelp.PluginOptions): void => {
    const router = options.router

    routes.forEach(route => {
      router.addRoute(route)
    })
  }
}

export default KwixeoHelp
